import { useState } from "react";
import { checkDuplicateIDBG } from "../lib/LoginServerCalls";

const useCheckIDBG = (URL) => {
  const [idbgExists, setIdbgExists] = useState();

  const checkDuplicate = async (idbg, serverUrl) => {
    if (!idbg) return;
    try {
      const result = await checkDuplicateIDBG(URL, idbg, serverUrl);
      setIdbgExists(result);
    } catch (error) {
      console.error("Failed to check IDBG:", error);
    }
  };

  return { idbgExists, checkDuplicate };
};

export default useCheckIDBG;
